import { Button, Form, Menu, Modal, Tile } from 'react-bulma-components';
import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';

import Folder from '../containers/folder';
import ReactTooltip from 'react-tooltip';
import { useSnackbar } from 'react-simple-snackbar';

const { Control, Field, Input, Label } = Form;

const MUTATEFOLDERRESPONSE_DEFINITION = gql`
    fragment MutateFolderResponse_Definition on MutateFolderResponse {
      success
      message
      folder {
        id
        name
        items{
          id
          kind
          name
        }
      }
    }
  `;

const RENAME_FOLDER = gql`
mutation renameFolder($parentId: String!, $id: String!, $name: String!)
{
  renameFolder(parentId: $parentId, id: $id, name: $name)
  {
    ...MutateFolderResponse_Definition
  }
}
${MUTATEFOLDERRESPONSE_DEFINITION}
`;
const ADD_FOLDER = gql`
mutation addFolder($parentId: String!, $name: String!)
{
  addFolder(parentId: $parentId, name: $name)
  {
    ...MutateFolderResponse_Definition
  }
}
${MUTATEFOLDERRESPONSE_DEFINITION}
`;
const DELETE_FOLDER = gql`
mutation deleteFolder($parentId: String!, $id: String!)
{
  deleteFolder(parentId: $parentId, id: $id)
  {
    ...MutateFolderResponse_Definition
  }
}
${MUTATEFOLDERRESPONSE_DEFINITION}
`;
const ADD_FILE = gql`
mutation addFile($parentId: String!, $name: String!, $kind: String!, $file: String!)
{
  addFile(parentId: $parentId, name: $name, kind: $kind, file: $file)
  {
    ...MutateFolderResponse_Definition
  }
}
${MUTATEFOLDERRESPONSE_DEFINITION}
`;
const DELETE_FILE= gql`
mutation deleteFile($parentId: String!, $id: String!)
{
  deleteFile(parentId: $parentId, id: $id)
  {
    ...MutateFolderResponse_Definition
  }
}
${MUTATEFOLDERRESPONSE_DEFINITION}
`;


const Finder = ({ rootFolder, onItemSelect, fileName, getFileOnAdd }) => {
  const [openSnackbar] = useSnackbar();
  const [openModal, setOpenModal] = useState();
  const [name, setName] = useState();
  const [newFileName, setNewFileName] = useState(fileName ? fileName : "New file");
  const [parentId, setParentId] = useState();
  const [id, setId] = useState();
  const [currentItemId, setCurrentItemId] = useState();
  const [path, setPath] = useState('/');

  const [addFolder, { loading: mutationAddLoading, error: mutationAddError }] = useMutation(ADD_FOLDER,
    {
      onError(error) {
        openSnackbar(error.message, 2000);
      },
      onCompleted(data) {
        closeModal();
        openSnackbar(data.addFolder.message, 2000);
      }
    });
  const [renameFolder, { loading: mutationRenameLoading, error: mutationRenameError }] = useMutation(RENAME_FOLDER,
    {
      onError(error) {
        openSnackbar(error.message, 2000);
      },
      onCompleted(data) {
        closeModal();
        openSnackbar(data.renameFolder.message, 2000);
      }
    });
  const [deleteFolder, { loading: mutationDeleteLoading, error: mutationDeleteError }] = useMutation(DELETE_FOLDER,
    {
      onError(error) {
        openSnackbar(error.message, 2000);
      },
      onCompleted(data) {
        openSnackbar(data.deleteFolder.message, 2000);
      }
    });
  const [addFile, { loading: mutationAddFileLoading, error: mutationAddfileError }] = useMutation(ADD_FILE,
    {
      onError(error) {
        closeModal();
        openSnackbar(error.message, 2000);
      },
      onCompleted(data) {
        closeModal();
        openSnackbar(data.addFile.message, 2000);
      }
    });
    const [deleteFile, { loading: mutationFileDeleteLoading, error: mutationFileDeleteError }] = useMutation(DELETE_FILE,
      {
        onError(error) {
          openSnackbar(error.message, 2000);
        },
        onCompleted(data) {
          onItemSelect(null);
          openSnackbar(data.deleteFile.message, 2000);
        }
      });

  const contextAddFolder = (data) => {
    console.log(data);
    var obj = JSON.parse(data);
    if (obj.k !== 'dir' && !obj.r) {
      openSnackbar("You can only add new folder to other folders.", 2000);
      return;
    }
    if (obj !== null) {
      setName("New folder");
      setParentId(obj.id);
      setOpenModal("add");
    }
  }
  const contextRename = (data) => {
    console.log(data);
    var obj = JSON.parse(data);
    if (obj.r) {
      openSnackbar("You can not rename a root folder.", 2000);
      return;
    }
    if (obj !== null) {
      setName(obj.n);
      setParentId(obj.pid);
      setId(obj.id);
      setOpenModal("rename");
    }
  }
  const contextDelete = (data) => {
    var obj = JSON.parse(data);
    if (obj.r) {
      openSnackbar("You can not delete a root folder.", 2000);
      return;
    }
    if (obj !== null) {
      if(obj.k==="dir")
      {
        deleteFolder({
          variables:
          {
            parentId: obj.pid,
            id: obj.id
          }
        });
      }
      if(obj.k==="exc")
      {
        deleteFile({
          variables:
          {
            parentId: obj.pid,
            id: obj.id
          }
        });
      }
      // TODO clean up and remove Folder:id and FolderItem:id from Apollo cache
    }
  }
  const contextAddFile = (data) => {
    console.log(data);
    var obj = JSON.parse(data);
    if (obj !== null) {
      setParentId(obj.id);
      setId(obj.id);
      setOpenModal("addFile");
    }
  }

  const handleNameChange = (evt) => {
    setName(evt.target.value);
  }
  const closeModal = () => {
    setOpenModal("");
  }
  const saveModal = () => {
    renameFolder({
      variables:
      {
        parentId: parentId,
        id: id,
        name: name
      }
    })
  }
  const addModal = () => {
    addFolder({
      variables:
      {
        parentId: parentId,
        name: name
      }
    })
  }
  const addFileModal = () => {
    var file = "{}";
    if(getFileOnAdd)
    {
      file = JSON.stringify(getFileOnAdd());
    }
    addFile({
      variables:
      {
        parentId: parentId,
        name: newFileName,
        kind: "exc",
        file: file,
      }
    })
  }

  return (
    <>
      <ReactTooltip
        id="folderContext"
        place="bottom"
        effect="solid"
        clickable={true}
        type="light"
        border={true}
        borderColor="orange"
        globalEventOff="click"
        getContent={(dataTip) => {
          var obj = JSON.parse(dataTip);
          return (
            <Menu>
              <Menu.List>
                {obj && (obj.k === 'dir' || obj.r) &&
                  <>
                    <Menu.List.Item onClick={() => contextAddFolder(dataTip)}>Add folder</Menu.List.Item>
                    <Menu.List.Item onClick={() => contextAddFile(dataTip)}>Add file</Menu.List.Item>
                  </>
                }
                <Menu.List.Item onClick={() => contextRename(dataTip)}>Rename</Menu.List.Item>
                <Menu.List.Item onClick={() => contextDelete(dataTip)}>Delete</Menu.List.Item>
              </Menu.List>
            </Menu>
          )
        }
        }
      >

      </ReactTooltip>

      <Modal show={openModal === "add"} onClose={closeModal} showClose={false}>
        <Modal.Card>
          <Modal.Card.Header showClose={false}>
            <Modal.Card.Title>Add</Modal.Card.Title>
          </Modal.Card.Header>
          <Modal.Card.Body>
            <Field>
              <Label>Name</Label>
              <Control>
                <Input onChange={handleNameChange} name="name" type="text" value={name} />
              </Control>
            </Field>
            <Field kind="group">
              <Control>
                <Button onClick={closeModal}>Cancel</Button>
              </Control>
              <Control>
                <Button onClick={addModal} color="success">Add</Button>
              </Control>
            </Field>
          </Modal.Card.Body>
        </Modal.Card>
      </Modal>
      <Modal show={openModal === "rename"} onClose={closeModal} showClose={false}>
        <Modal.Card>
          <Modal.Card.Header showClose={false}>
            <Modal.Card.Title>Rename</Modal.Card.Title>
          </Modal.Card.Header>
          <Modal.Card.Body>
            <Field>
              <Label>Name</Label>
              <Control>
                <Input onChange={handleNameChange} name="name" type="text" value={name} />
              </Control>
            </Field>
            <Field kind="group">
              <Control>
                <Button onClick={closeModal}>Cancel</Button>
              </Control>
              <Control>
                <Button onClick={saveModal} color="success">Save</Button>
              </Control>
            </Field>
          </Modal.Card.Body>
        </Modal.Card>
      </Modal>
      <Modal show={openModal === "addFile"} onClose={closeModal} showClose={false}>
        <Modal.Card>
          <Modal.Card.Header showClose={false}>
            <Modal.Card.Title>Add file</Modal.Card.Title>
          </Modal.Card.Header>
          <Modal.Card.Body>
            <Field>
              <Label>Name</Label>
              <Control>
                <Input onChange={(evt) => setNewFileName(evt.target.value)} name="name" type="text" value={newFileName} />
              </Control>
            </Field>
            <Field kind="group">
              <Control>
                <Button onClick={closeModal}>Cancel</Button>
              </Control>
              <Control>
                <Button onClick={addFileModal} color="success">Save</Button>
              </Control>
            </Field>
          </Modal.Card.Body>
        </Modal.Card>
      </Modal>

      <Field>
        <Control>
          <Input size="small" disabled placeholder="Path" value={path} />
        </Control>
      </Field>
      <Tile kind="ancestor" className="is-gapless">
        <Folder
          name={rootFolder}
          path=""
          setPath={setPath}
          onItemSelect={onItemSelect}
          currentItemId={currentItemId}
          setCurrentItemId={setCurrentItemId} />
      </Tile>
    </>
  )
}


export default Finder;